function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Slider from "react-slick";
import { classNamesConfig } from "../../../Shared/features/classnames";
import { Link } from "./library/link";
import { SliderTeaser, Teasers } from "./teaser";
export class CarouselContentGridBlock extends React.Component {
    componentDidMount() {
        this.mediaquery.addListener(this.handleResize);
    }
    componentWillUnmount() {
        this.mediaquery.removeListener(this.handleResize);
    }
    render() {
        const p = this.props;
        const teaserprops = p.items.map((i, k)=>({
                key: `carousel-content-grid-item-${k}`,
                extraClasses: 'teaser--audience block__item col-xs-12 col-sm-6 col-md-4',
                headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
                title: i.title,
                linkUrl: i.linkUrl,
                intro: i.subtitle,
                label: i.label,
                imageUrl: i.imageUrl,
                imageUrlFallback: i.imageUrlFallback,
                imageUrlLarge: i.imageUrlLarge,
                imageAlt: i.imageAlt,
                video: i.video
            })).toList();
        const classNames = classNamesConfig().caroussel;
        return /*#__PURE__*/ _jsx("section", {
            className: `block block--content-grid-carousel ${classNames.block}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `block__inner`,
                children: [
                    p.title && p.title != "" && /*#__PURE__*/ _jsx("header", {
                        className: `block__header ${classNames.inner}`,
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l container--xs",
                            children: p.title
                        })
                    }),
                    this.state.mobile ? /*#__PURE__*/ _jsx(Slider, {
                        accessibility: true,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        className: "center",
                        centerMode: true,
                        centerPadding: "0",
                        speed: 500,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        dotsClass: "slick-dots",
                        children: teaserprops.map((i)=>/*#__PURE__*/ _jsx(SliderTeaser, {
                                ...i
                            }))
                    }) : /*#__PURE__*/ _jsx(Teasers, {
                        items: teaserprops
                    }),
                    p.primaryActionTitle && p.primaryActionUrl && /*#__PURE__*/ _jsx("footer", {
                        className: `block__actions ${classNames.inner}`,
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "button button--primary button--arrow",
                            url: p.primaryActionUrl,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "button__label",
                                children: p.primaryActionTitle
                            })
                        })
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "mediaquery", window.matchMedia("(max-width: 1024px)")), _define_property(this, "handleResize", (e)=>this.setState((s)=>({
                    ...s,
                    mobile: e.matches
                })));
        this.state = {
            mobile: this.mediaquery.matches
        };
    }
}
{}